module.exports = __webpack_public_path__ + "img/brazo-extensor-1.48450bf9.png";